<div class="row {{(!integrationDetailsDisabled?'cursor-pointer':'')}}" (click)="!innerClicked && routeToDetails()">

    <div class="border-left-5"></div>

    <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value max-width-250 ">

        <div class="row base-style cell-base-sty "
            (click)="routeToDetails()" >
            <img class="image-1-src" *ngIf="isDestination === true" src="../../assets/images/datawarehouselogos/{{params.data.logoUrl}}.png"  />
            <img class="image-1-src" *ngIf="isDestination !== true" src="../../assets/images/source-logos/pngFormat/{{params.data.logoUrl }}"  />
            <div class="basic-margin grid-cell text-capitalize"> {{params.data.integrationName }} </div>
            <i class="icon dripicons-information des-icon" *ngIf="params.data.description !== '' && params.data.description !== undefined" [matTooltip]="params.data.description"></i>
        </div>

    </div>

    <!--name-->
    <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value min-width-250-last">
            <div class=" margin-top-29 cell-base-sty row  h-100 to-left-1 " (click)="routeToDetails()" >

                    <ng-container *ngIf="!(params.data.lastSyncTime === undefined)">
                        <div  class="alert alert-nobg alert-{{params.data.lastSyncStatus}} tooltip tooltip-bottom"
                            matTooltip="{{((params.data.lastSyncStatus === 'warning' || params.data.lastSyncStatus === 'error') && params.data.errorTables === false)? 'Click to get info':''}}"
                            (click)="getTables(params.data)"
                            [ngClass]="params.data.errorTables ? 'active' : ''">
                            <div class="alert-body ">
                                <!-- <div class="alert-icon mt-0">
                                    <i class="fa fa-exclamation-circle" *ngIf="params.data.lastSyncStatus === 'warning'"></i>
                                    <i class="fa fa-times-circle" *ngIf="params.data.lastSyncStatus === 'error'"></i>
                                    <i class="fa fa-check-circle" *ngIf="params.data.lastSyncStatus === 'success'"></i>
                                </div> -->
                                <div class="alert-message text-secondary">
                {{params.data.lastSyncTime}}
                                <span *ngIf="params.data.lastSyncTime !== '-/-'">ago</span>
                                </div>

                                <div *ngIf="params.data.lastSyncTime !== '-/-' " class="pipe-line"></div>
                                <div class="alert-icon mt-0">
                                    <i class="fa fa-exclamation-circle" *ngIf="params.data.lastSyncStatus === 'warning'"></i>
                                    <i class="fa fa-times-circle" *ngIf="params.data.lastSyncStatus === 'error'"></i>
                                    <i class="fa fa-check-circle" *ngIf="params.data.lastSyncStatus === 'success'"></i>
                                </div>
                                <div class="alert-message cap">
                                    {{params.data.lastSyncStatus}}
                                </div>

                            </div>
                        </div>
                        <!-- <div  class="grid-cell text-truncate px-0 m-l12 m-t-22">
                        </div> -->
                   </ng-container>
                   <span class="loading-dots" *ngIf="(params.data.lastSyncTime === undefined)">Loading</span>
            </div>

    </div>


    <!-- last-->

    <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value min-width-250-next">

            <div class="margin-top-29 cell-base-sty row h-100 to-left-1  " (click)="!innerClicked && routeToDetails()">

                    <ng-container  *ngIf="(params.data.nextSyncInfo !== undefined)">

                            <div class= "m-r-13" *ngIf="(isOrgAdmin || params.data.userId == rootUserId) &&  !(params.data.destinationName === null || params.data.nextSyncInfo === 'Pending' ||
                            params.data.nextSyncInfo === 'Updated' ||
                            params.data.nextSyncInfo === 'Sync in progress' ||
                            params.data.nextSyncInfo === 'Attempting to start' ||
                            params.data.nextSyncInfo === '-/-' )" (click)="innerClicked = true; startSource(params.data)">
                            <span class="sync-now line-h">
                                <i class="cloud-icon"></i>
                                <span>
                                    Sync now
                                </span>
                            </span>
                        </div>

                        <div class="line-h-20">
                            <div class="label-05"
                                *ngIf="!(params.data.nextSyncInfo === 'Attempting to start' || params.data.destinationName === null ||
                                params.data.nextSyncInfo === 'Pending' ||
                                params.data.nextSyncInfo === 'Updated' ||
                                params.data.nextSyncInfo === 'Scheduled' ||
                                params.data.nextSyncInfo === 'Sync in progress' ||
                                params.data.nextSyncInfo === '-/-')">Sync will start</div>
                            <div class="text-strong-2 text-truncate {{(params.data.nextSyncInfo === 'Pending' || params.data.nextSyncInfo === 'Updated')?'pending-updated':''}}
                                {{(params.data.nextSyncInfo === 'Attempting to start' || params.data.nextSyncInfo === 'Sync in progress')?'cus-wdth-sync':''}}">
                                <span
                                *ngIf="!(params.data.nextSyncInfo === 'Attempting to start' || params.data.destinationName === null ||
                                params.data.nextSyncInfo === 'Pending' ||
                                params.data.nextSyncInfo === 'Updated' ||
                                params.data.nextSyncInfo === 'Scheduled' ||
                                params.data.nextSyncInfo === 'Sync in progress' ||
                                params.data.nextSyncInfo === '-/-')">After</span> {{params.data.nextSyncInfo}}
                                <span class="loading-dots"
                                    *ngIf="params.data.nextSyncInfo === 'Sync in progress' ||
                                    params.data.nextSyncInfo === 'Attempting to start'"></span></div>
                        </div>

                    </ng-container>

                    <span class="loading-dots" *ngIf="(params.data.nextSyncInfo === undefined)">Loading</span>




                </div>

    </div>

        <!--next-->



    <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value max-width-100 left-750">

            <div (click)="routeToDetails()" class="cell-base-sty margin-top-29">
                    <img [matTooltip]="params.data.destinationName"
                        class="image-1-src tooltip hover-tooltip tooltip-sm"
                        *ngIf="params.data.destlogoUrl !== null && params.data.destlogoUrl !== undefined"
                        src="../../assets/images/datawarehouselogos/{{params.data.destlogoUrl}}.png"  />


                </div>





                                        <div class="d-flex margin-top-29 row  h-100" *ngIf="params.data.destlogoUrl === null || params.data.destlogoUrl === undefined"  >

                                            <div class="ml-3">
                                             <div class="Integrations-dropdown">
                                                <span  *ngIf="params.data.destlogoUrl === undefined" [matTooltip]="'Cannot set destination for this source'">+</span>
                                                <span (click)="status=!status" *ngIf="params.data.destlogoUrl === null" [ngClass]="status ? 'show' : ''">+</span>
                                                 <div class="Integrations-dropdown-list my-scrollbar" >
                                                     <h6 class="mb-1">Choose Destination</h6>
                                                     <p>Select the destination that you want to map for your source</p>
                                                     <div class="Integrations-overflow">
                                                         <ul class="Integrations-ul">
                                                             <ng-container *ngFor="let warehouse of params.data.warehouses; let i = index" >

                                                                <li *ngIf="warehouse.status === 'ENABLED'"  class="click-f {{(i === focusIndex?'focus-class':'')}}" (click)="focusIndex = i">
                                                                        <div class="Integrations-img">
                                                                            <img src="../../assets/images/datawarehouselogos/{{warehouse.logoUrl}}.png" alt="">
                                                                        </div>
                                                                        <div class="Integrations-details">
                                                                            <span class="text-strong-2">{{warehouse.name}}</span>
                                                                            <p>Receiving from {{warehouse.count}} sources</p>
                                                                        </div>
                                                                </li>

                                                             </ng-container>


                                                         </ul>
                                                     </div>
                                                     <div class="Integrations-addnew mt-3">
                                                         <span (click)="routeToDest()"><i class="fas fa-plus"></i> Add new Destination</span>
                                                     </div>
                                                     <div class="row justify-content-end mt-4">
                                                         <div class="col-auto"><button mat-button color="primary" (click)="status=!status; focusIndex = undefined;">Cancel</button></div>
                                                         <div class="col-auto pl-0"><button mat-flat-button color="primary" [disabled]="focusIndex === undefined" (click)="setWarehouse()">Confirm</button></div>
                                                     </div>

                                                 </div>
                                                </div>
                                            </div>
                                        </div>


    </div>

     <!--destination-->
     <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value width-200 left-850">

            <div class="cell-base-sty margin-top-29 row h-100 to-left-1 " (click)="!isDestination && routeToDetails()">
                    <div >
                       <span class="{{params.data.displayStatus}} status-bar"> {{params.data.displayStatus | titlecase}}</span>
                    </div>
                 </div>

     </div>


         <!--status-->
    <div class="ag-cell ag-cell-not-inline-editing ag-cell-auto-height ag-cell-value width-200 left-1050">
            <div class="cell-base-sty m-t-19 d-flex h-100  " (click)="!isDestination && !innerClicked && routeToDetails()">
                    <div class="">
                    <div class="setting dropdown m-t-15" [matTooltip]="'Click for options'"  *ngIf="isDestination !== true" (click)="innerClicked = true; toggleDropDown(params.data.sourceId, params.data.status)" [ngClass]="params.data.settingStatus ? 'show' : ''" #dropdownActive>
                        <a  href="javascript:void(0);" class="dropdown-click  tooltip hover-tooltip tooltip-sm"><i class="fa fa-cog font-18"></i>
                            <!-- <div class="tooltip-section fade-in">
                                <div  class="tooltip-body" >
                                        Click for options
                                </div>
                            </div> -->
                        </a>
                        <!---->
                        <div class="dropdown-menu {{(!(rowIndex === 0 || rowIndex === 1)) ?'drop-down-bttm':''}}" >
                            <ul >
                             <li *ngIf="params.data.status !== 'SAVED'" ><a class="dropdown-item" [ngClass]="{'disabled':!(params.data.destinationName !== null && (isOrgAdmin || (params.data.userId == userId)) && (params.data.loginType =='OAUTH2'))}" href="javascript:void(0);" (click)="onchangeRenewToken(params.data.sourceId,'renew',params.data.datasourceId)" ><span class="mr-2 font-14"><i class="icon dripicons-clockwise"></i></span>Re-Authenticate</a></li>
                             <li *ngIf="params.data.status !== 'SAVED'"><a class="dropdown-item" [ngClass]="{'disabled':!(params.data.destinationName !== null && (isOrgAdmin || (params.data.userId == userId)) && (params.data.status != 'CREATED' && params.data.status != 'DELETED' && params.data.status != 'UPDATED' && params.data.status != 'PAUSED'))}" [routerLink]="baseWord | editIntegrationLink:params.data.datasourceId:params.data.integrationName:params.data.sourceId"><span class="mr-2 font-14"><i class="icon dripicons-pencil"></i></span> Edit configuration</a></li>
                             <li ><a class="dropdown-item" routerLink="/{{baseWord}}/clone-integration/{{params.data.datasourceId}}/{{params.data.sourceId}}"><span class="mr-2 font-14"><i class="icon dripicons-copy"></i></span> Clone Integration</a></li>
                             <li *ngIf="params.data.status !== 'SAVED'"><a class="dropdown-item" [ngClass]="{'disabled': integrationDetailsDisabled }" routerLink="/{{baseWord}}/integration-details/{{params.data.integrationName}}/{{params.data.sourceId}}"><span class="mr-2 font-14"><i class="icon dripicons-preview"></i></span> Integration details</a></li>
                             <li *ngIf="['ENABLED', 'CREATED', 'UPDATED','RESCHEDULED'].includes(params.data.status)"><a class="dropdown-item pointer-exp"  [ngClass]="{'disabled':(!params.data.destinationName !== null && (params.data.status == 'ENABLED') || !(isOrgAdmin || (params.data.userId == userId)))}" (click)="onChangeSourceStatus(params.data.sourceId,'paused',false, 'active')"><span class="mr-2 font-14"><i class="icon dripicons-media-pause"></i></span> Pause integration </a></li>
                             <li *ngIf="params.data.status === 'PAUSED'"><a class="dropdown-item pointer-exp"  [ngClass]="{'disabled': (!(isOrgAdmin || (params.data.userId == userId)))}" (click)="onChangeSourceStatus(params.data.sourceId,'paused',$event, 'paused', params.data.datasourceId)"><span class="mr-2 font-14"><i class="icon dripicons-media-play"></i></span> Activate integration </a></li>
                             <li *ngIf="params.data.status !== 'SAVED'"><a (click)="onChangeSourceStatus(params.data.sourceId,'deleted',$event, 'active')" class="dropdown-item" href="javascript:void(0);"><span class="mr-2 font-14"><i class="icon dripicons-trash"></i></span>Delete integration</a></li>

                            </ul>

                        </div>
                    </div>
                    <div class="setting dropdown m-t-15" *ngIf="isDestination === true" (click)="toggleDropDownWarehouse(params.data.warehouseId)" [ngClass]="params.data.settingStatus ? 'show' : ''" #dropdownActive>
                        <a  href="javascript:void(0);" class="dropdown-click  tooltip hover-tooltip tooltip-sm"><i class="fa fa-cog font-18"></i>
                            <!-- <div class="tooltip-section fade-in">
                                <div  class="tooltip-body" >
                                        Click for options
                                </div>
                            </div> -->
                        </a>
                        <!---->
                        <div class="dropdown-menu {{(!(rowIndex === 0 || rowIndex === 1)) ?'drop-down-bttm2':''}}">

                            <ul >
                                <li ><a class="dropdown-item {{(params.data.displayStatus === 'DELETED' ?'disabled':'')}}"  routerLink="/{{baseWord}}/edit-warehouse/{{params.data.datawarehouseId}}/{{params.data.warehouseId}}"><span class="mr-2 font-14"><i class="icon dripicons-pencil"></i></span> Edit destination</a></li>
                                <!-- <li><a class="dropdown-item disabled" ><span class="mr-2 font-14"><i class="icon dripicons-preview"></i></span> Integration details</a></li> -->
                                <!-- <li><a class="dropdown-item pointer-exp"  [ngClass]="{'disabled':(!(params.data.status == 'ENABLED') || !(isOrgAdmin || (params.data.userId == userId)))}" (click)="onChangeSourceStatus(params.data.sourceId,'paused',false, 'active')"><span class="mr-2 font-14"><i class="icon dripicons-media-pause"></i></span> Pause integration </a></li> -->
                                <li ><a (click)="onChangeWarehouseStatus('delete')"  class="dropdown-item" href="javascript:void(0);"><span class="mr-2 font-14"><i class="icon dripicons-trash"></i></span> Delete warehouse</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                </div>

    </div>



  <!--action-->




  </div>

  <div class="row {{(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status)?'cursor-pointer':'')}}" (click)="!innerClicked && routeToDetails()">

        <div class="alert alert-error-pending alert-custom-sty" *ngIf="params.data.destlogoUrl === null">
                <div class="alert-body" >
                    <div class="alert-icon ptop-2">
                        <img src="../../assets/images/icons/alert.svg">
                    </div>
                    <div class="alert-message error-color">
                            Destination mapping is pending, complete the mapping and start replicating the data.
                    </div>
                </div>
            </div>

            <div class="alert  {{(params.data.status === 'UPDATED')?'alert-message': 'alert-error-pending' }} alert-custom-sty" *ngIf="params.data.destlogoUrl !== null ">
                <div class="alert-body ptop-2" >
                    <div class="alert-icon">
                            <img src="../../assets/images/icons/alert.svg">
                    </div>
                    <div class="alert-message error-color" *ngIf="params.data.status === 'CREATED'">
                            The sync status of the integration will change once Daton creates tables in the warehouse and schedules jobs. This will take a few minutes.
                    </div>
                    <div class="alert-message error-color" *ngIf="params.data.status === 'ENABLED'">
                        Configuration failed for the source
                    </div>
                    <div class="alert-message info-color" *ngIf="params.data.status === 'UPDATED'">
                        Daton will process the requested modifications to the source, shortly.
                    </div>
                </div>
            </div>




  </div>
